export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9635.9527baf5.jpg";